import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const carouselRow = () => {
	const elements = document.querySelectorAll('.row--carousel');
	if (!elements) return;

	elements.forEach((element) => {
		const swiperElement = element.querySelector('.swiper');
		if (swiperElement) {
			const swiperPagination = element.querySelector('.row__slides__pagination');
			const numberOfSlides = swiperElement.querySelectorAll('.swiper-slide');
			const autoscroll = swiperElement.classList.contains('autoscroll');

			const swiper = new Swiper(swiperElement, {
				modules: [Pagination],
				centeredSlides: true,
				loop: numberOfSlides.length > 8,
				autoplay: autoscroll,
				slidesPerView: 1.25,
				spaceBetween: 10,
				breakpoints: {
					767: {
						slidesPerView: 2.25,
						spaceBetween: 20
					},
					992: {
						slidesPerView: 2.50,
						spaceBetween: 20
					},
					1200: {
						slidesPerView: 3.25,
						spaceBetween: 30
					},
					1500: {
						slidesPerView: 3.50,
						spaceBetween: 30
					}
				},
				pagination: {
					el: swiperPagination,
					type: 'bullets',
					clickable: true,
				},
			});
		}
	});

};

export default carouselRow;
